module.exports = __webpack_public_path__ + "static/media/moreImageIcon.d8fd774b.svg";